import { useState } from "react";
import useDebtWarehouseImportTab from "../../hooks/useDebtWarehouseImportTab";
import { Stack, Box, Button, Typography } from "@mui/material";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import TableComp from "src/components/shared/table/TableComp";
import DebtFilter from "../../components/DebtFilter";
import { DebtWarehouseBulkPaymentDialog, DebtWarehouseHistoryDetailDialog } from "../Dialogs";
import { formatCurrency } from "src/helper/convertNum";
import convertCurrency from "src/helper/convertCurrency";
import { enqueueSnackbar } from "notistack";
import { DEBT_COLOR_INBOUND } from "../../utils/renderDebtAmountByInventoryType";

const DebtWarehouseImportTab = ({ date }) => {
  const [searchValue, setSearchValue] = useState();
  const [filter, setFilter] = useState();
  const [isMultiplePayment, setIsMultiplePayment] = useState(false);

  const { bodyList, sortData, header, pagi, setPagi, total, totalExportTransferDebt, checkedList, selectedRow, setSelectedRow, detailSelectedRow, setDetailSelectedRow } =
    useDebtWarehouseImportTab({
      date,
      filter,
      searchValue,
    });

  const handleClosePayment = () => {
    setSelectedRow(null);
    setIsMultiplePayment(false);
  };

  const handleCloseDetail = () => {
    setDetailSelectedRow(null);
  };

  const handleMultiplePayment = () => {
    if (checkedList.length) {
      const distinctDebtWarehouse = new Set(checkedList.map((item) => item?.warehouseDebt?._id));
      if (distinctDebtWarehouse.size > 1) {
        enqueueSnackbar("Không thể thanh toán hàng loạt công nợ với kho nhận khác nhau", { variant: "error" });
        return;
      }
    }
    setIsMultiplePayment(true);
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        my="14px"
      >
        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
          minWidth="198px"
        >
          <SearchFilterComp
            getSearchKeyword={setSearchValue}
            placeholder="Mã phiếu nhập"
            width="100%"
          />
        </Box>
        <Stack
          direction="row"
          gap={2}
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleMultiplePayment}
          >
            Thanh toán hàng loạt
          </Button>
          <DebtFilter
            variant="debt-warehouse"
            setParamsQuery={setFilter}
            paramsQuery={filter}
          />
        </Stack>
      </Stack>
      <TableComp
        bodyList={bodyList}
        headers={header}
        sortData={sortData}
        setPagi={setPagi}
        pagi={pagi}
        total={total}
        noBackground
        TableFooterComponent={
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            spacing={4}
            sx={{ py: 2, borderTop: "1px solid var(--grey)" }}
          >
            <Typography fontWeight="bold">Tổng:</Typography>
            <Stack alignItems="center">
              <Typography
                fontWeight="bold"
                sx={{ color: DEBT_COLOR_INBOUND }}
              >
                -{formatCurrency(Math.abs(totalExportTransferDebt ?? 0))}
              </Typography>
              <Typography
                color="#989898"
                fontSize="8px"
                fontStyle="italic"
              >
                {convertCurrency(totalExportTransferDebt ?? 0)} đồng
              </Typography>
            </Stack>
          </Stack>
        }
      />
      <DebtWarehouseBulkPaymentDialog
        open={!!selectedRow || isMultiplePayment}
        onClose={handleClosePayment}
        isMultiplePayment={isMultiplePayment}
        title={!selectedRow ? "Thanh toán hàng loạt công nợ hàng nhập" : `Thanh toán công nợ ${selectedRow?.code}`}
        selectedRow={selectedRow}
        checkedList={checkedList}
      />
      <DebtWarehouseHistoryDetailDialog
        open={!!detailSelectedRow}
        onClose={handleCloseDetail}
        selectedRow={detailSelectedRow}
        isAllTab
      />
    </>
  );
};

export default DebtWarehouseImportTab;
